module.exports = __webpack_public_path__ + "static/media/cvut_logo.15ed31ee.png";